import script from "./AsignarTareasDirectorView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AsignarTareasDirectorView.vue?vue&type=script&lang=ts&setup=true"

import "./AsignarTareasDirectorView.vue?vue&type=style&index=0&id=7f2153d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f2153d7"]])

export default __exports__